<template>
  <div class="basicInformation">
    <div class="common_group">
      <div class="title">
        <img src="@/assets/images/informationIcon.png">
        <span>{{ $t('general.BasicInfo') }}</span>
      </div>
      <div class="common_readonly_template">
        <el-row>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('approvalCenter.ActivityNumber') }}</div>
              <div class="text">{{ basicData.activityCode }}</div>
            </div>
          </el-col>
          <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.BasicInfo.fs') }}</div>
              <div class="text">{{ basicData.financialSystemName }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.BasicInfo.toc') }}</div>
              <div class="text">{{ basicData.currencyType }}</div>
            </div>
          </el-col> -->
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.BasicInfo.Applicant') }}</div>
              <div class="text">{{ basicData.userData }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.BasicInfo.ci') }}</div>
              <div class="text">{{ basicData.applyUserTel }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.BasicInfo.at') }}</div>
              <div class="text">{{ basicData.applyTime }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.BasicInfo.cs') }}</div>
              <div class="text">{{ basicData.saler }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="common_group">
      <div class="title">
        <img src="@/assets/images/informationIcon.png">
        <span>{{ $t('newApp.activityInfo.ei') }}</span>
      </div>
      <div class="common_readonly_template">
        <el-row>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.noa') }}</div>
              <commonTooltip class="text" ref-name="basicDataActivityName" :content="basicData.activityName" />
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.businessUnit">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.bu') }}</div>
              <commonTooltip class="text" ref-name="basicDataBusinessUnit" :content="basicData.businessUnit" />
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.coa') }}</div>
              <div class="text">{{ basicData.activityClassification }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.relatedActivityName && basicData.relatedActivityCode && basicData.relationActivityName">
            <div>
              <div class="label">{{ basicData.relationActivityName }}</div>
              <commonTooltip class="text" ref-name="basicDataRelatedActivityName" :content="hdActiveValue" />
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.foa') }}</div>
              <div class="text">{{ basicData.activityForms }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.organizer">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.Organizer') }}</div>
              <div class="text">{{ basicData.organizer }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.tnoptbi') }}</div>
              <div class="text">{{ basicData.inviterNum }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.targetObject">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.mta') }}</div>
              <div class="text">{{ formatTargetObject(basicData.targetObject, basicData.targetObjectOther) }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.toa') }}</div>
              <div class="text">{{ basicData.activityType }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.qdMeetingSegment">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.cms') }}</div>
              <div class="text">{{ basicData.qdMeetingSegment }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!$store.state.useSimplifiedForm">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.ps') }}</div>
              <div class="text">{{ basicData.brandPromotionSupport }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.hc') }}</div>
              <div class="text">{{ basicData.city }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.edoh') }}</div>
              <div class="text">{{ basicData.expectStartDate }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.eed') }}</div>
              <div class="text">{{ basicData.expectEndDate }}</div>
            </div>
          </el-col>
          <el-col v-if="lang === 'zh-CN' && !$store.state.useSimplifiedForm" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.hdcdtj') }}</div>
              <div class="text active-text" @click="goToLook">{{ $t('general.ctView') }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.activityBaseName">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.hdjd') }}</div>
              <div class="text">{{ basicData.activityBaseName }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.activityBaseContactInformation">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.jdlx') }}</div>
              <div class="text">{{ basicData.activityBaseContactInformation }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.salerDeptCode && basicData.salerDeptCode.indexOf('000063') === 0">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.jma') }}</div>
              <div class="text">{{ basicData.isUnionMarket ? $t('general.yes') : $t('general.no') }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.isUnionMarket === 1">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.ic') }}</div>
              <div class="text">{{ basicData.isInternationalQd ? $t('general.yes') : $t('general.no') }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.isUnionMarket === 1">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.cst') }}</div>
              <div class="text">{{ basicData.unionChannelType }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.isUnionMarket === 1">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.cn') }}</div>
              <div class="text">{{ basicData.unionChannelName }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!belongToSbg && lang === 'zh-CN' && !$store.state.useSimplifiedForm">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.csl') }}</div>
              <div class="text">{{ basicData.activityLevelName }}</div>
            </div>
          </el-col>
          <!-- 高层/关键客户活动（简化UI用户） -->
          <el-col v-if="$store.state.useSimplifiedForm" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.skca') }}</div>
              <div class="text">{{ basicData.seniorKeyCustomerActivity === '1' ? $t('general.yes') : basicData.seniorKeyCustomerActivity === '0' ? $t('general.no') : '--' }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.activityClassificationCode === 'AC_06'">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.dynags') }}</div>
              <div class="text">{{ basicData.needOrganizer ? $t('general.yes') : $t('general.no') }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.budgetAmount">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.ba') }}</div>
              <div class="text">{{ basicData.budgetAmount }}</div>
            </div>
          </el-col>
          <!-- 是否年度规划线上活动 -->
          <el-col v-if="ifcomplianceDocuments" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.sfndghxshd') }}</div>
              <div class="text">{{ basicData.isCompliance ? $t('general.yes') : $t('general.no') }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="basicData.organizerReason">
            <div>
              <div class="label">{{ $t('approvalCenter.ReasonsApplication') }}</div>
              <div class="text">{{ basicData.organizerReason }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.remotePoc && !$store.state.useSimplifiedForm">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.rp') }}</div>
              <div class="text">{{ basicData.remotePoc }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.unitedDiamondActivity && !$store.state.useSimplifiedForm">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.jra') }}</div>
              <div class="text">{{ basicData.unitedDiamondActivity }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.circleActivity && !$store.state.useSimplifiedForm">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.ca') }}</div>
              <div class="text">{{ basicData.circleActivity }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.templateVisit && !$store.state.useSimplifiedForm">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.mv') }}</div>
              <div class="text">{{ basicData.templateVisit }}</div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.machineDemo && !$store.state.useSimplifiedForm">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.machineDemo') }}</div>
              <div class="text">{{ basicData.machineDemo }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactModuleList && editEchoData.mactModuleList.length > 0">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.teietcs') }}</div>
              <div class="text">{{ basicData.mactModuleList }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactProductLineList && editEchoData.mactProductLineList.length > 0">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.artpl') }}</div>
              <div class="text">{{ basicData.productlineSupplement }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactCommunicationScenarioList && editEchoData.mactCommunicationScenarioList.length > 0 && lang === 'zh-CN'">
            <div>
              <div class="label">{{ comscValue }}</div>
              <div class="text">{{ basicData.communicationScenarioList || '--' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactAgendaList && editEchoData.mactAgendaList.length > 0">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.agenda') }}</div>
              <div class="text">{{ basicData.agendaList }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.ActivityBgA') }}</div>
              <div class="text">{{ basicData.activityBackgroundPurpose || '--' }}</div>
            </div>
          </el-col>
          <!-- 活动目标（简化UI用户） -->
          <el-col v-if="$store.state.useSimplifiedForm" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div>
              <div class="label">{{ $t('newApp.activityInfo.hdmb') }}</div>
              <div class="text">{{ basicData.activityTarget || '--' }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { arrRemoveDuplication } from '@/utils/utils';
import commonTooltip from '@/components/commonTooltip';
import { isNotEmpty } from '../../../../../utils/utils';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { targetObjectDisplayMixin } from '@/views/newApplicationForm/mixins/targetObjectMixin';
const CLASSIFICATION_WHITELIST = new Set(['AC_06', 'AC_02', 'AC_01']);
const ONLINE_FORMS = new Set(['线上活动', '1+N（线上线下结合）', 'Online Event']);

export default {
  mixins: [targetObjectDisplayMixin],
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTooltip
  },
  data () {
    return {
      basicData: {},
      belongToSbg: false,
      lang: localStorage.getItem('lang') || 'zh-CN',
      comscValue: ''
    };
  },
  computed: {
    hdActiveValue () {
      let value = '';
      switch (this.basicData.activityClassificationCode) {
      case 'AC_03':
      case 'AC_06':
        value = this.basicData.hqActivityName;
        break;
      case 'AC_01':
        value = this.basicData.relatedActivityName;
        break;
      }
      return value;
    },
    ifcomplianceDocuments () {
      // 活动分类 - activityClassificationCode
      // 活动形式 - activityForms
      const { activityClassificationCode, activityForms } = this.basicData;
      if (!activityClassificationCode || !activityForms) return false;
      return CLASSIFICATION_WHITELIST.has(activityClassificationCode) &&
              ONLINE_FORMS.has(activityForms);
    }
  },
  watch: {
    editEchoData: {
      handler (newVal) {
        if (newVal) {
          this.basicData = {
            ...newVal.marketActivityExpand,
            ...newVal.marketActivity
          };
          this.basicData.userData = `${this.basicData.applyUserName} / ${this.basicData.applyUserDeptName}`;
          this.basicData.saler = `${this.basicData.salerName} / ${this.basicData.salerDeptName}`;
          this.init();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {

  },
  methods: {
    goToLook () {
      window.open('https://ruijie.feishu.cn/share/base/query/shrcnLYaqtH3GcUGNq84cJclTTd');
    },
    init () {
      let params = [
      'plate', // 预计板块
      'qd_meeting_segment', // 渠道会议细分
      'activity_type', // 活动类型
      'organizer', // 主办方
      'target_object', // 目标对象
      'other_classification', // 其他分类
      'union_market_help',
      'activity_forms',
      'activity_classification',
      'productline_supplement',
      'activity_goal',
      'expense_detail_item',
      'smb_international_activity_type',
      'activity_level'
    ];
    // 获取活动相关下拉数据（如活动分类、活动层级等）
    newApplicationFormApi.getActivityList(params).then(res => {
      const data = res.data;
      // 获取活动分类列表
      const activity_classification = data.activity_classification;
      // 在活动分类中查找与当前活动分类编码匹配的项
      const found = activity_classification.find(item => item.fieldKey === this.basicData.activityClassificationCode);
      if (found) {
        // 将匹配到的fieldValue赋值给relationActivityName（活动分类名称）
        this.$set(this.basicData, 'relationActivityName', found.fieldValue);
      }
      // 获取活动层级列表
      const activity_level = data.activity_level;
      // 在活动层级中查找与当前活动层级编码匹配的项
      const levelFound = activity_level.find(item => item.fieldKey === this.basicData.activityLevel);
      if (levelFound) {
        // 将匹配到的fieldValue赋值给activityLevelName（活动层级名称）
        this.$set(this.basicData, 'activityLevelName', levelFound.fieldValue);
      }
    });
    // switch (this.basicData.activityClassificationCode) {
    //   case 'AC_03':
    //   case 'AC_06':
    //     this.basicData.relationActivityName = this.$t('home.ha');
    //     break;
    //   case 'AC_01':
    //     this.basicData.relationActivityName = this.$t('newApp.activityInfo.ta');
    //     break;
    // }
    //  switch (this.basicData.activityLevel) {
    //   case 'A':
    //      this.basicData.activityLevelName = "A类重点活动";
    //     break;
    //   case 'B':
    //     this.basicData.activityLevelName = "B类小型会议";
    //     break;
    //   case 'C':
    //      this.basicData.activityLevelName = "C类关系活动";
    //     break;
    //     case 'D':
    //      this.basicData.activityLevelName = "D类数字营销";
    //     break;
    // }
    if (this.basicData.salerDeptCode.startsWith('000063')) {
      this.belongToSbg = true;
    } else {
      this.belongToSbg = false;
    }
    if (this.editEchoData.mactAgendaList && this.editEchoData.mactAgendaList.length > 0) {
      // 议程回显
      this.basicData.viewAgenda = [];
      this.editEchoData.mactAgendaList.forEach(item => {
        if (item.agendaName && item.agendaName !== '无') {
          this.basicData.viewAgenda.push(item.agendaName);
        }
      });
      // 行业回显
      let industryList = arrRemoveDuplication(this.editEchoData.mactAgendaList, 'industryCode');
      this.basicData.viewIndustry = [];
      industryList.forEach(item => {
        if (item.industryName) {
          this.basicData.viewIndustry.push(item.industryName);
        }
      });
    }
    // 活动预计板块
    if (this.editEchoData.mactModuleList && this.editEchoData.mactModuleList.length > 0) {
      this.basicData.mactModuleList = this.editEchoData.mactModuleList.map(item => {
        return item.moduleName;
      }).join('，');
    }
    // 产品线
    if (this.editEchoData.mactProductLineList && this.editEchoData.mactProductLineList.length > 0) {
      this.basicData.productlineSupplement = this.editEchoData.mactProductLineList.map(item => {
        if (item.productLineName.indexOf('其他') >= 0) {
          item.productLineName = item.customProductLine;
        }
        return item.productLineName;
      }).join('，');
    }
    if (isNotEmpty(this.editEchoData.mactCommunicationScenarioList)) {
      this.basicData.communicationScenarioList = this.editEchoData.mactCommunicationScenarioList.map(item => {
        return item.communicationScenarioName;
      }).join('，');
      let params = ['fb_communication_scenario'];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          const list = res.data.fbCommunicationScenario.filter(item => item.flag);
          const index = list.findIndex(item => item.fieldKey === this.editEchoData.mactCommunicationScenarioList[0].communicationScenarioCode);
          if (index !== -1) {
            this.comscValue = this.$t('newApp.activityInfo.strpr');
          } else {
            this.comscValue = this.$t('newApp.activityInfo.comsc');
          }
        }
      });
    }
    if (isNotEmpty(this.editEchoData.mactAgendaList)) {
      this.basicData.agendaList = this.editEchoData.mactAgendaList.map(item => {
        return item.agendaName;
      }).join('，');
    }
    }
  }
};
</script>

<style lang="scss" scoped>
.active-text{
  color:#14937b;
  cursor: pointer;
}
</style>
